import React, { useState, useEffect } from "react";
import BASE_URL from "../../config";
import { useNavigate } from "react-router-dom";
export default function AboutUs() {
  const [about, setAbout] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    getAbout();

    const interval = setInterval(() => {
      getAbout();
    }, 5000); // refresh every 5 sec

    return () => clearInterval(interval);
  }, []);

  const getAbout = () => {
    fetch(`${BASE_URL}/api/getAbout.php`, {
      cache: "no-store",
    })
      .then((res) => res.json())
      .then((data) => setAbout(data))
      .catch((err) => console.error("Error:", err));
  };
  const [team, setTeam] = useState([]);

  useEffect(() => {
    getTeam();

    const interval = setInterval(() => {
      getTeam();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const getTeam = () => {
    fetch(`${BASE_URL}/api/getTeam.php?t=${Date.now()}`)
      .then((res) => res.json())
      .then((data) => setTeam(data))
      .catch((err) => console.error("Error:", err));
  };

  const [activePlan, setActivePlan] = useState("bachat");

  return (
    <div className="about-page">
      <div className="about-hero">
        {/* LEFT: Static Home Page Content */}

        <div className="about-text">
          <div className="trust-header1">
            <span className="trust-tag1">About US</span>
            <div className="section-main-header">
              <h1>અમારી સંસ્થા વિશે</h1>
              <p>વિશ્વાસ, વિકાસ અને મહિલાઓના સશક્તિકરણ માટે પ્રતિબદ્ધ</p>
            </div>
          </div>
          <h2 style={{ fontSize: "25px" }}>સંસ્થાનો પરિચય</h2>

          <p>
            શ્રી ગૃહલક્ષ્મી અર્બન કો.ઓપ. થ્રીફ્ટ, ક્રેડિટ એન્ડ કન્ઝયુમર સોસાયટી
            લી. એ માત્ર એક નાણાકીય સંસ્થા નથી, પરંતુ મહિલાઓના આર્થિક
            સશક્તિકરણનું એક માધ્યમ છે. અમારી સંસ્થાનો મુખ્ય ઉદ્દેશ્ય મહિલાઓમાં
            બચતની વૃત્તિ કેળવવી અને તેમને આર્થિક રીતે પગભર થવા માટે સરળ ધિરાણ
            પૂરું પાડવાનો છે. સહકાર અને વિશ્વાસના પાયા પર બનેલી આ સોસાયટી
            વર્ષોથી મહિલાઓના ઉત્થાન માટે કાર્યરત છે.
          </p>
        </div>

        {/* RIGHT: Dynamic About Image */}

        <div className="about-image">
          <img
            src={
              about?.image
                ? `${BASE_URL}/uploads/${about.image}`
                : "images/2.jpeg"
            }
            alt="about"
          />
        </div>
      </div>
      <div className="mission-section">
        <div className="row g-4">
          {/* Objective */}
          <div className="col-lg-6">
            <div className="vision-card">
              <div className="floating-shape"></div>

              <div className="vision-top">
                <div className="vision-icon">
                  <i className="bi bi-gem"></i>
                </div>

                <div>
                  <span className="small-tag">OUR PURPOSE</span>
                  <h2>અમારો ઉદ્દેશ</h2>
                </div>
              </div>

              <ul className="vision-list">
                <li>સભાસદો ને રોકાણ અને બચત માટે પ્રોત્સાહિત કરવા.</li>
                <li>સભાસદો ના રોકાણ પાર મહત્તમ વળતર.</li>
                <li>
                  અમારી સોસાયટી સભાસદો ને આર્થિક રીતે મજબૂત બનાવવા માટે લોન તેમજ
                  વીમા સુવિધા પુરી પડે છે.
                </li>
              </ul>
            </div>
          </div>

          {/* Goal */}
          <div className="col-lg-6">
            <div className="vision-card goal-card">
              <div className="floating-shape"></div>

              <div className="vision-top">
                <div className="vision-icon">
                  <i className="bi bi-bullseye"></i>
                </div>

                <div>
                  <span className="small-tag">OUR GOAL</span>
                  <h2>અમારું ધ્યેય</h2>
                </div>
              </div>

              <ul className="vision-list">
                <li>
                  આર્થિક જરૂરિયાત ધરાવતા લોકો અને બચત કરનારા લોકો વચ્ચે સુમેળ
                  કરાવવો.
                </li>
                <li>ગુજરાત ની નામાંકિત સહકારી સંસ્થા બનાવવી.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="head">
        <h2>અમારા માટે દરેક સભાસદ મહત્વપૂર્ણ અને તેમનું હીત સર્વોપરી છે.</h2>
      </div>

      {/* HISTORY & FOUNDATION */}
      <div className="about-section-container">
        {/* SECTION HEADER */}

        {/* 2x2 GRID FOR THE MAIN TOPICS */}
        <div className="topics-grid-layout">
          {/* CARD 1: સંસ્થાનો ઇતિહાસ અને સ્થાપના */}
          <div className="topic-card-box card-bg-history">
            <div className="card-top-content">
              {/* Header Row */}
              <div className="card-header-flex">
                <div className="icon-wrapper-box">
                  <i className="bi bi-bank"> </i>
                </div>
                <h2>સંસ્થાનો ઇતિહાસ અને સ્થાપના</h2>
              </div>

              {/* Central Pill Badge */}
              <div className="badge-pill-tag-container">
                <span className="badge-pill-tag">
                  <i
                    className="bi bi-calendar3"
                    style={{ paddingRight: "5px" }}
                  >
                    {" "}
                  </i>
                  મહિલાઓથી સમૃદ્ધિ તરફ – ૧૯૯૯ થી કાર્યરત
                </span>
              </div>

              {/* Gujarati Typography Content */}
              <div className="card-body-paragraphs">
                <p>
                  શ્રી ગૃહલક્ષ્મી અર્બન કો.ઓપ. થ્રીફ્ટ, ક્રેડિટ એન્ડ કન્ઝયુમર
                  સોસાયટી લી. ની સ્થાપના વર્ષ ૧૯૯૯ માં કરવામાં આવી હતી. છેલ્લા
                  એક દાયકાથી પણ વધુ સમયથી અમારી સંસ્થા મહિલાઓને આર્થિક રીતે
                  સક્ષમ અને આત્મનિર્ભર બનાવવાના મિશન સાથે કાર્ય કરી રહી છે.
                </p>
                <p>
                  શરૂઆતમાં એક નાનકડા હેતુ સાથે સ્થપાયેલી આ સોસાયટી આજે હજારો
                  મહિલા સભાસદોનો વિશ્વાસ જીતી ચૂકી છે. ૧૯૯૯ થી અત્યાર સુધીની
                  અમારી સફર પારદર્શિતા, સુરક્ષા અને મહિલા ઉત્થાનના મજબૂત પાયા પર
                  ટકેલી છે.
                </p>
              </div>

              {/* Recreated Vector Background Asset (Pure Inline SVG) */}
              <div className="card-bottom-vector">
                <svg
                  viewBox="0 0 400 140"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="vector-svg"
                >
                  {/* Base Foundations */}
                  <path
                    d="M40 135 H360 M55 131 H345 M65 127 H335"
                    stroke="#90b3e8"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <rect
                    x="75"
                    y="115"
                    width="250"
                    height="12"
                    rx="1"
                    fill="#e8f1ff"
                    stroke="#90b3e8"
                    strokeWidth="1.5"
                  />

                  {/* Columns & Main Architecture */}
                  <rect
                    x="85"
                    y="55"
                    width="230"
                    height="60"
                    fill="#f0f6ff"
                    stroke="#90b3e8"
                    strokeWidth="1.5"
                  />
                  <g fill="#abcbee" stroke="#90b3e8" strokeWidth="1.5">
                    <rect x="100" y="55" width="12" height="60" rx="1" />
                    <rect x="132" y="55" width="12" height="60" rx="1" />
                    <rect x="164" y="55" width="12" height="60" rx="1" />
                    <rect x="194" y="55" width="12" height="60" rx="1" />
                    <rect x="224" y="55" width="12" height="60" rx="1" />
                    <rect x="256" y="55" width="12" height="60" rx="1" />
                    <rect x="288" y="55" width="12" height="60" rx="1" />
                  </g>

                  {/* Pediment Roof Structure */}
                  <polygon
                    points="70,55 200,20 330,55"
                    fill="#f0f6ff"
                    stroke="#90b3e8"
                    strokeWidth="2"
                    strokeLinejoin="round"
                  />
                  <circle
                    cx="200"
                    cy="40"
                    r="6"
                    fill="none"
                    stroke="#90b3e8"
                    strokeWidth="1.5"
                  />

                  {/* Left Decorative Tree Accent */}
                  <g opacity="0.8">
                    <line
                      x1="45"
                      y1="125"
                      x2="45"
                      y2="95"
                      stroke="#90b3e8"
                      strokeWidth="2"
                    />
                    <line
                      x1="45"
                      y1="110"
                      x2="38"
                      y2="103"
                      stroke="#90b3e8"
                      strokeWidth="1.5"
                    />
                    <line
                      x1="45"
                      y1="105"
                      x2="52"
                      y2="98"
                      stroke="#90b3e8"
                      strokeWidth="1.5"
                    />
                    <circle
                      cx="45"
                      cy="90"
                      r="14"
                      fill="#e1eeff"
                      stroke="#90b3e8"
                      strokeWidth="1.5"
                      strokeDasharray="3 2"
                    />
                  </g>

                  {/* Right Decorative Tree Accent */}
                  <g opacity="0.8">
                    <line
                      x1="355"
                      y1="125"
                      x2="355"
                      y2="95"
                      stroke="#90b3e8"
                      strokeWidth="2"
                    />
                    <line
                      x1="355"
                      y1="112"
                      x2="362"
                      y2="105"
                      stroke="#90b3e8"
                      strokeWidth="1.5"
                    />
                    <line
                      x1="355"
                      y1="106"
                      x2="348"
                      y2="99"
                      stroke="#90b3e8"
                      strokeWidth="1.5"
                    />
                    <circle
                      cx="355"
                      cy="90"
                      r="14"
                      fill="#e1eeff"
                      stroke="#90b3e8"
                      strokeWidth="1.5"
                      strokeDasharray="3 2"
                    />
                  </g>

                  {/* Soft Distant Bush Silhouettes */}
                  <path
                    d="M25 127 Q35 115 45 127 Q55 118 68 127"
                    fill="none"
                    stroke="#abcbee"
                    strokeWidth="1.5"
                    opacity="0.6"
                  />
                  <path
                    d="M332 127 Q342 115 352 127 Q362 118 375 127"
                    fill="none"
                    stroke="#abcbee"
                    strokeWidth="1.5"
                    opacity="0.6"
                  />
                </svg>
              </div>
            </div>
          </div>

          {/* CARD 2: અમારો અનુભવ અને સિદ્ધિઓ */}
          <div className="topic-card-box card-bg-experience">
            <div className="card-header-flex">
              <div className="icon-wrapper-box">
                <i className="bi bi-trophy"></i>
              </div>
              <h2>અમારો અનુભવ અને સિદ્ધિઓ</h2>
            </div>

            <ul className="custom-checkmark-list">
              <li>
                <div className="list-check-icon">
                  <i className="bi bi-check-circle"></i>
                </div>
                <div className="list-text-wrapper">
                  <strong>૨૮ વર્ષનો અનુભવ:</strong> <br /> ૧૯૯૯ થી સતત બેંકિંગ
                  અને ધિરાણ ક્ષેત્રે બહેનોને શ્રેષ્ઠ સેવા પૂરી પાડી રહ્યા છીએ.
                </div>
              </li>
              <li>
                <div className="list-check-icon">
                  <i className="bi bi-check-circle"></i>
                </div>
                <div className="list-text-wrapper">
                  <strong>વિશ્વાસનું પ્રતીક:</strong> <br /> સ્થાપના કાળથી જ અમે
                  સભાસદોની મૂડીની સુરક્ષા અને યોગ્ય વળતરને પ્રાધાન્ય આપ્યું છે.
                </div>
              </li>
              <li>
                <div className="list-check-icon">
                  <i className="bi bi-check-circle"></i>
                </div>
                <div className="list-text-wrapper">
                  <strong>મહિલા સશક્તિકરણ:</strong> <br /> છેલ્લા 28 વર્ષમાં
                  અનેક મહિલાઓને પોતાનો નાનો વ્યવસાય શરૂ કરવા માટે આર્થિક ટેકો
                  પૂરો પાડ્યો છે.
                </div>
              </li>
            </ul>
          </div>

          {/* CARD 3: વિઝન અને મિશન */}
          <div className="topic-card-box card-bg-vision">
            <div className="card-header-flex mb-large">
              <div className="icon-wrapper-box">
                <i className="bi bi-people-fill"></i>
              </div>
              <h2>વિઝન અને મિશન</h2>
            </div>

            <div className="subcards-two-column">
              {/* Vision Subcard */}
              <div className="inner-subcard vision-blue">
                <div className="subcard-icon-circle text-blue">
                  <img src="images/vison.png" alt="Promotional Gift" />
                </div>
                <h3>વિઝન</h3>
                <p>
                  ૧૯૯૯ માં જે ઉદ્દેશ્ય સાથે શરૂઆત કરી હતી, તે મુજબ દરેક ગૃહિણી
                  અને કામકાજી મહિલાને કરકસર અને બચત દ્વારા આર્થિક રીતે મજબૂત
                  બનાવવી.
                </p>
              </div>

              {/* Mission Subcard */}
              <div className="inner-subcard mission-green">
                <div className="subcard-icon-circle text-green">
                  {" "}
                  <img src="images/mission.png" alt="Promotional Gift" />
                </div>
                <h3>મિશન</h3>
                <p>
                  ટેકનોલોજી અને સહકારના સમન્વયથી આગામી વર્ષોમાં રાજ્યની અગ્રણી
                  મહિલા ક્રેડિટ સોસાયટી બનવું.
                </p>
              </div>
            </div>
          </div>

          {/* CARD 4: સભાસદોને પ્રોત્સાહક ભેટ */}
          <div className="topic-card-box card-bg-gifts">
            {/* 1. Main Header */}
            <div className="card-header-flex mb-large">
              <div className="icon-wrapper-box">
                <i className="bi bi-gift-fill"></i>
              </div>
              <h2>સભાસદોને પ્રોત્સાહક ભેટ</h2>
            </div>

            {/* 2. Middle Grid Layout: Left 3D Asset & Right Stack Content */}
            <div className="gift-grid-container">
              {/* Left Presentation Panel */}
              <div className="gift-visual-panel">
                <div className="gift-image-wrapper">
                  {/* Replace with your 3D gift box image path */}
                  <img
                    src="images/gift.png"
                    alt="Promotional Gift"
                    className="main-gift-graphic"
                  />
                </div>
              </div>

              {/* Right Info Stack */}
              <div className="gift-rows-stack">
                {/* Gift Row 1 */}
                <div className="gift-row-item">
                  <div className="gift-action-icon">
                    <i className="bi bi-gift-fill"></i>
                  </div>
                  <div className="gift-row-content">
                    <h4>દિવાળી કે વાર્ષિક ભેટ:</h4>
                    <p>
                      દર વર્ષે વાર્ષિક સભા દરમિયાન અથવા તહેવારોના સમયે સભાસદોને
                      ઉપયોગી વસ્તુઓ ભેટ (Gifts) તરીકે આપવામાં આવે છે.
                    </p>
                  </div>
                </div>

                {/* Gift Row 2 */}
                <div className="gift-row-item">
                  <div className="gift-action-icon">
                    <i className="bi bi-mortarboard-fill"></i>
                  </div>
                  <div className="gift-row-content">
                    <h4>શૈક્ષણિક પુરસ્કાર:</h4>
                    <p>
                      સભાસદોના તેજસ્વી સંતાનોને શૈક્ષણિક પ્રોત્સાહન ઇનામો
                      આપવામાં આવે છે.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* 3. Bottom Row Split Highlights */}
            <div className="gift-footer-highlights">
              {/* Left Highlight - Festive Gold Box */}
              <div className="footer-pill-box gold-pill">
                <div className="pill-icon">
                  <i className="bi bi-gift"></i>
                </div>
                <div className="pill-text">
                  <h5>તહેવારની વિશેષ ભેટ</h5>
                  <p>દર વર્ષે ખાસ ભેટ આપવામાં આવે છે</p>
                </div>
              </div>

              {/* Right Highlight - Academic Purple Box */}
              <div className="footer-pill-box purple-pill">
                <div className="pill-icon">
                  <i className="bi bi-award-fill"></i>
                </div>
                <div className="pill-text">
                  <h5>શૈક્ષણિક પ્રોત્સાહન</h5>
                  <p>તેજસ્વી વિદ્યાર્થીઓને ઇનામ</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="trust-section">
        <div className="trust-header">
          <span className="trust-tag">WHY CHOOSE US</span>

          <h2>અમને કેમ પસંદ કરશો?</h2>

          <p>
            વિશ્વાસ, સુરક્ષા અને પારદર્શક સેવાઓ સાથે મહિલાઓ માટે ખાસ બનાવેલ
            સહકારી સંસ્થા.
          </p>
        </div>

        <div className="modern-container">
          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-check-circle"></i>
            </div>
            <h4>પારદર્શક વહીવટ</h4>
            <p>સંપૂર્ણ પારદર્શક અને કાયદેસરની કામગીરી.</p>
          </div>

          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-people"></i>
            </div>
            <h4>મહિલા સંચાલિત</h4>
            <p>મહિલાઓ દ્વારા, મહિલાઓ માટે અને મહિલાઓનું સંગઠન.</p>
          </div>

          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-lightning"></i>
            </div>
            <h4>આકર્ષક વ્યાજ દર</h4>
            <p>થાપણો પર વધુ વ્યાજ અને લોન પર વ્યાજબી દર.</p>
          </div>

          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-shield-lock"></i>
            </div>
            <h4>સરળ પ્રક્રિયા</h4>
            <p>લોન અને ખાતા ખોલાવવા માટેની ન્યૂનતમ દસ્તાવેજી પ્રક્રિયા.</p>
          </div>
        </div>
      </div>

      {/* SERVICES */}
      {/* SERVICES */}

      <div className="plan-detail">
        <div className="membership-title">
          <h2 style={{ marginBottom: "40px" }}>અમારી સેવાઓ</h2>
        </div>

        <div className="zigzag-wrapper">
          {/* ===================== BACHAT ===================== */}
          <div className="zigzag-row1" id="bachat">
            <div className="zigzag-tag">Saving Plan</div>
            <div className="poster-title1">
              {" "}
              ❖ વિવિધ પ્રકારની માસિક તેમજ દૈનિક બચત યોજના ❖
            </div>
            <div className="bachat-banner" id="bachat">
              <div className="banner-overlay"></div>

              <div className="banner-left">
                <h1>
                  સાથે મળીને બનાવીએ
                  <br />
                  <span>સશક્ત સમાજ</span>
                </h1>

                <p>જરૂરિયાતમંદ પરિવારોને આર્થિક સહાય</p>

                <div className="feature-boxes">
                  <div className="feature-item blue">
                    <i className="bi bi-heart-fill"></i>
                    <span>અનુકૂળ રકમ ની શરૂઆત</span>
                  </div>

                  <div className="feature-item green">
                    <i className="bi bi-people-fill"></i>
                    <span>માસિક રોકાણ , મહત્તમ લાભ</span>
                  </div>

                  <div className="feature-item orange">
                    <i className="bi bi-award-fill"></i>
                    <span>સુરક્ષિત રોકાણ નિશ્ચિત જીવન</span>
                  </div>
                </div>

                <div className="highlight-box">
                  <div className="highlight-icon">
                    <i className="bi bi-currency-rupee"></i>
                  </div>

                  <div className="highlight-content">
                    ફક્ત ₹૫૦૦/- કે તેના ગુણાંકમાં ૧ વર્ષની મુદત માટે ખાતું
                    ખોલાવી શકાય છે.
                  </div>
                </div>
              </div>
            </div>
            <div className="saving-plan-section">
              <div className="saving-card purple1">
                <div className="saving-icon">
                  <i className="bi bi-wallet2"></i>
                </div>

                <p>₹૫૦૦/- નાં ૧૨ માસ</p>
                <h3>મુજબ રકમ ₹૬૩૦૦/-</h3>
              </div>

              <div className="saving-card green1">
                <div className="saving-icon">
                  <i className="bi bi-wallet2"></i>
                </div>

                <p>₹૧૦૦૦/- નાં ૧૨ માસ</p>
                <h3>મુજબ રકમ ₹૧૨૬૦૦/-</h3>
              </div>

              <div className="saving-card pink">
                <div className="saving-icon">
                  <i className="bi bi-wallet2"></i>
                </div>

                <p>₹૨૦૦૦/- નાં ૧૨ માસ</p>
                <h3>મુજબ રકમ ₹૨૫૨૦૦/-</h3>
              </div>

              <div className="saving-card orange">
                <div className="saving-icon">
                  <i className="bi bi-wallet2"></i>
                </div>

                <p>₹૫૦૦૦/- નાં ૧૨ માસ</p>
                <h3>મુજબ રકમ ₹૬૩૦૦૦/-</h3>
              </div>
            </div>

            <div className="gift-banner">
              <i className="bi bi-shield-check"></i>

              <span>
                દરેક ખાતા પર એક આકર્ષક <strong>ગિફ્ટ</strong> તો ખરી જ !
              </span>

              <i className="bi bi-gift-fill gift-icon"></i>
            </div>
            <div className="saving-section-bg">
              <div className="saving-header">
                <div className="saving-title">દૈનિક બચત યોજના</div>

                <h3 className="saving-subtitle">
                  બચત એટલે ભવિષ્યના પૈસાની સાચવણી નહીં, પણ તમારા સ્વપ્નોનું
                  રોકાણ છે.
                </h3>

                <div className="saving-highlight">
                  <i className="bi bi-shield-fill-check"></i>
                  <span style={{ background: "transparent" }}>
                    સંસ્થા ના કર્મચારી રૂબરૂ દૈનિક બચત લેવા તમારા ઘરે અથવા દુકાન
                    પર આવશે.
                  </span>
                </div>
              </div>

              <div className="saving-benefits">
                <div className="benefit-item">
                  <i className="bi bi-shield-check"></i>
                  <span>સુરક્ષિત રોકાણ</span>
                </div>

                <div className="benefit-item">
                  <i className="bi bi-graph-up-arrow"></i>
                  <span>આકર્ષક વ્યાજદર</span>
                </div>

                <div className="benefit-item">
                  <i className="bi bi-currency-exchange"></i>
                  <span>નિયમિત અને સરળ બચત</span>
                </div>

                <div className="benefit-item">
                  <i className="bi bi-people-fill"></i>
                  <span>સુરક્ષિત ભવિષ્યની ખાતરી</span>
                </div>
              </div>
            </div>
          </div>

          {/* ===================== LOAN ===================== */}

          <div className="zigzag-row loan-poster" id="fd">
            <div className="row">
              <div className="col-md-6">
                <div className="zigzag-image12">
                  <img src="/images/fd1.png" alt="" />
                </div>
              </div>
              <div className="col-md-6 col">
                <div className="mar">
                  <div className="zigzag-tag">Fixed Deposit</div>
                  <div className="poster-title">❖ ફિક્સ ડિપોઝિટ યોજના ❖</div>
                  <div className="deposit-plans-wrap">
                    <div className="row g-4">
                      <div className="col-md-6">
                        <div className="deposit-card plan-one">
                          <div className="rate-badge">૧ વર્ષ માટે</div>
                          <h2>૭.૫%</h2>
                          <p>વાર્ષિક વ્યાજ દર</p>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="deposit-card plan-two">
                          <div className="rate-badge">૨ વર્ષ માટે</div>
                          <h2>૮.૫%</h2>
                          <p>વાર્ષિક વ્યાજ દર</p>
                        </div>
                      </div>
                    </div>

                    <div className="special-offer gift-card">
                      <div className="offer-icon">
                        <i className="bi bi-gift-fill"></i>
                      </div>

                      <div>
                        <h3>૩ વર્ષ માટે ૯.૫%</h3>
                        <p>₹૨૫,૦૦૦/- કે તેથી વધુ ની રકમ પર આકર્ષક ફ્રી ગિફ્ટ</p>
                      </div>
                    </div>

                    <div className="special-offer double-money">
                      <div className="offer-icon">
                        <i className="bi bi-coin"></i>
                      </div>

                      <div>
                        <h3>8 વર્ષે બમણાં</h3>
                        <p>₹૫,૦૦૦/- કે તેથી વધુ ની રકમ પર આકર્ષક ફ્રી ગિફ્ટ</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* ===================== INSURANCE ===================== */}

          <div className="zigzag-row loan-poster" id="insurance">
            <div className="row">
              <div className="col-md-8">
                {" "}
                <div>
                  <div className="zigzag-tag">Insurance Plan</div>
                  <div className="poster-title">❖ વીમા યોજના ❖</div>

                  <h5
                    style={{
                      fontWeight: "600",
                      fontSize: "20px",
                      color: "#e24118",
                    }}
                  >
                    તા. ૦૧/૦૪/૨૦૨૩ થી શ્રી ગૃહલક્ષ્મી સુરક્ષા કવચ વીમા યોજના
                    ₹૨,૦૦,૦૦૦/- સંપૂર્ણપણે ચાલુ છે.
                  </h5>
                  <h5
                    style={{
                      fontWeight: "600",
                      fontSize: "20px",
                      color: "#589167",
                    }}
                  >
                    વીમાયોજનામાં જોડનાર દરેક સભાસદને ફ્રી ગિફ્ટ નો લાભ મળશે.
                  </h5>
                  <ul className="zigzag-list">
                    <li>
                      ઘણા સમયથી સભાસદ ભાઈઓ તથા બહેનોના સતત આગ્રહ અને માંગણીને
                      ધ્યાનમાં રાખીને તા: ૦૧/૦૯/૨૦૨૫ થી “શ્રી ગૃહલક્ષ્મી સુરક્ષા
                      કવચ” વીમા યોજના ₹૩,૦૦,૦૦૦/- (ત્રણ લાખ) શરુ કરવા જઈ રહ્યા
                      છીએ, તેના અનુસંધાને તા: ૦૧/૦૯/૨૦૨૫ થી કુલ ૧૦૦૦ વીમા
                      યોજનાના સભાસદ થયેથી યોજના શરુ થશે.
                    </li>
                    <li>
                      તા: ૦૧/૦૪/૨૦૨૩ થી “ શ્રી ગૃહલક્ષ્મી સુરક્ષા કવચ” વીમા
                      યોજના ₹૨,૦૦,૦૦૦/- (બે લાખ) સંપૂર્ણપણે ચાલુ છે.
                    </li>

                    <li>
                      ₹૩,૦૦,૦૦૦/- ની વીમા યોજનાનો અમલ શરૂ ન થાય ત્યાં સુધી
                      ₹૨,૦૦,૦૦૦/- નો વીમો તો મળવાપાત્ર છે જ.
                    </li>

                    <li>
                      ₹૨,૦૦,૦૦૦/- (બે લાખ) વીમાયોજનામાં જે ચાલુ સભાસદો છે તેમણે
                      ફક્ત ₹૩૬૫૦/- (નોન રિફંડેબલ) ભર્યે થી નવી યોજના ₹૩,૦૦,૦૦૦/-
                      માં જોડાઈ ને વીમા નો લાભ મળવા પાત્ર બનશે.
                    </li>

                    <li>
                      ૧૮ થી ૫૫ વર્ષ સુધીનાં સભાસદ વીમા યોજના માં જોડાય શકશે,
                      તેમજ જ્યાં સુધી સભાસદ તરીકે ચાલુ રહેશે ત્યાં સુધી વીમો
                      મળવાપાત્ર છે.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-4">
                {" "}
                <div
                  className="zigzag-image1 col4"
                  style={{ marginTop: "60px", marginBottom: "10px" }}
                >
                  <img src="/images/vima.png" alt="" />
                </div>
              </div>
              <div className="col-md-12">
                <ul className="zigzag-list">
                  <li>
                    સદર મંડળીમાં વીમા યોજનામાં જોડાયેલા સભાસદે પ્રથમવાર વીમો
                    કરાવતી વખતે ફક્ત એક વખત ₹૮૬૫૦/- વીમા યોજના ફી ભરવાની રહેશે.
                    જે કોઈપણ સંજોગોમાં પરત મળવાપાત્ર નથી
                  </li>

                  <li>
                    વીમાદાર સભાસદ ના ખાતા માંથી સભાસદ દીઠ કોઈપણ વ્યક્તિ નું
                    મૃત્યુ થાય તે સમયે જે રકમ મંડળી દ્વારા નક્કી કરવામાં આવે તે
                    તેના ફરજીયાત રકમ ના ખાતામાંથી ઉધારવા માં આવશે.
                  </li>

                  <li>
                    સભાસદ થયા બાદ તરત જ ફરજીયાત બચતના ખાતા માંથી વીમા સહાય માટે
                    જે રકમ કપાયેલી હોય તે દર વર્ષે એપ્રિલ માં ફરજીયાત બચતની સાથે
                    જ ફરજીયાત જમા કરાવવાની રહેશે.
                  </li>

                  <li>
                    જે વીમાદાર સભાસદની ફરજીયાત બચત+વીમાપેટે કપાયેલી રકમ જમા
                    કરવાની બાકી હશે તો તે વીમો માન્ય ગણાશે નહી.
                  </li>

                  <li>
                    કોઈપણ વીમેદાર સભાસદ નું મૃત્યુ થશે તો સભાસદ ની ફરજીયાત બચત
                    બાકી હોય તો તે ભરેલી હોવી જોઈએ.
                  </li>

                  <li>
                    કોઈપણ લોન લેનાર સભાસદમાં જામીન થયેલા હશો, તે બાબત ક્લિયર ના
                    થાય ત્યાં સુધી પાકતી વિમાની રકમ અટકાવવામાં આવશે.
                  </li>

                  <li>
                    વીમાદાર વ્યક્તિ જે લોન લેનાર સભાસદમાં જામીન થયેલા હશે, જે
                    રેગ્યુલર સભાસદ હશે તો યોગ્ય બાબત વિચારી યોગ્ય કરવામાં આવશે.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* ================= LOAN FACILITY ================= */}

          <div className="loan-section" id="loan">
            <div className="poster-title">❖ લોન સુવિધા ❖</div>

            {/* PERSONAL LOAN */}
            <div className="loan-row">
              <div className="loan-left">
                <div className="loan-icon blue">
                  <i className="bi bi-person-fill"></i>
                </div>

                <div>
                  <h3>Personal Loan</h3>
                  <h5>(જાત જામીનગીરી લોન)</h5>

                  <span className="amount-badge">₹૨,૦૦,૦૦૦/- સુધી લોન</span>
                </div>
              </div>

              <div className="loan-features">
                <div className="loan-feature blue1">
                  <i className="bi bi-currency-rupee"></i>
                  <p>ઝડપી મંજૂરી</p>
                </div>

                <div className="loan-feature blue1">
                  <i className="bi bi-clock-fill"></i>
                  <p>ઓછી કાર્યવાહી</p>
                </div>

                <div className="loan-feature blue1">
                  <i className="bi bi-shield-check"></i>
                  <p>જાત જામીનગીરી લોન</p>
                </div>
              </div>

              <div className="loan-rate blue-rate blue1">
                <span>વ્યાજ દર</span>
                <h2 style={{ marginBottom: "5px" }}>૧૮%</h2>
              </div>

              <div className="loan-image">
                <img src="images/personalloan1.png" alt="" />
              </div>
            </div>

            {/* GOLD LOAN */}

            <div className="loan-row">
              <div className="loan-left">
                <div className="loan-icon gold">
                  <i className="bi bi-coin"></i>
                </div>

                <div>
                  <h3>Gold Loan</h3>
                  <h5>(ગોલ્ડ લોન)</h5>
                </div>
              </div>

              <div className="loan-features">
                <div className="loan-feature gold1">
                  <i className="bi bi-cash-stack"></i>
                  <p>સોનાના આધાર પર લોન</p>
                </div>

                <div className="loan-feature gold1">
                  <i className="bi bi-percent"></i>
                  <p>આકર્ષક વ્યાજ દર</p>
                </div>

                <div className="loan-feature gold1">
                  <i className="bi bi-shield-check"></i>
                  <p>સુરક્ષિત અને વિશ્વસનીય</p>
                </div>
              </div>

              <div className="loan-rate gold-rate">
                <span>વ્યાજ દર</span>
                <h2 style={{ marginBottom: "5px" }}>૧૦%</h2>
              </div>

              <div className="loan-image">
                <img src="images/gold.png" alt="" />
              </div>
            </div>

            {/* PROPERTY LOAN */}

            <div className="loan-row">
              <div className="loan-left">
                <div className="loan-icon green">
                  <i className="bi bi-house-door-fill"></i>
                </div>

                <div>
                  <h3>Property Loan</h3>
                  <h5>(મિલકતના તારણ પર લોન)</h5>

                  <span className="amount-badge">
                    ₹૩૦,૦૦,૦૦૦/- (ત્રીસ લાખ) સુધી
                  </span>
                </div>
              </div>

              <div className="loan-features">
                <div className="loan-feature green1">
                  <i className="bi bi-buildings-fill"></i>
                  <p>વધુ રકમની લોન</p>
                </div>

                <div className="loan-feature green1">
                  <i className="bi bi-percent"></i>
                  <p>આકર્ષક વ્યાજ દર</p>
                </div>

                <div className="loan-feature green1">
                  <i className="bi bi-check-circle-fill"></i>

                  <p>હપ્તા ની સંખ્યા</p>
                  <h2
                    style={{
                      fontSize: "20px",
                      marginBottom: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    ૧૨૦
                  </h2>
                </div>
              </div>

              <div className="loan-rate property-rate">
                <span>વ્યાજ દર</span>
                <h2 style={{ marginBottom: "5px" }}>૧૮%</h2>
              </div>

              <div className="loan-image">
                <img src="images/homeloan.jpg" alt="" />
              </div>
            </div>

            {/* CONSUMER LOAN */}

            <div className="loan-row">
              <div className="loan-left">
                <div className="loan-icon purple">
                  <i className="bi bi-cart-fill"></i>
                </div>

                <div>
                  <h3>Consumer Loan</h3>
                  <h5>(અનાજ ધિરાણ)</h5>

                  <span className="amount-badge ">
                    ₹૨૫,૦૦૦/- (પચ્ચીસ હજાર ) સુધી
                  </span>
                </div>
              </div>

              <div className="loan-features">
                <div className="loan-feature purple1">
                  {/* <p>દર વર્ષે 12 માસનું શોપિંગ</p> */}
                  {/* <i className="bi bi-calendar-check-fill"></i> */}
                  <p>
                    {" "}
                    દર વર્ષે સભાસદો માટે ૧૨ માસનું અનાજ, કરિયાણું વગેરે એક સાથે
                    ભરવા માટે ₹૨૫,૦૦૦/- સુધીની તુરંત જ લોન
                  </p>
                </div>

                <div className="loan-feature purple1">
                  <i className="bi bi-percent"></i>
                  <p>આકર્ષક વ્યાજ દર</p>
                </div>

                <div className="loan-feature purple1">
                  <i className="bi bi-check-circle-fill"></i>

                  <p>હપ્તા ની સંખ્યા</p>
                  <h2
                    style={{
                      fontSize: "20px",
                      marginBottom: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    ૧૦
                  </h2>
                </div>
              </div>

              <div className="loan-rate consumer-rate">
                {/* <div className="consumer-special">
                  દર વર્ષે સભાસદો માટે 12 માસનું અનાજ, કરિયાણું વગેરે એક સાથે
                  ભરવા માટે 25,000/- સુધીની તુરંત જ લોન
                </div> */}
                <span>વ્યાજ દર</span>
                <h2 style={{ marginBottom: "5px" }}>૧૦%</h2>
              </div>

              <div className="loan-image">
                <img src="images/consumerloan.png" alt="" />
              </div>
            </div>

            {/* VEHICLE LOAN */}

            <div className="loan-row">
              <div className="loan-left">
                <div className="loan-icon cyan">
                  <i className="bi bi-car-front-fill"></i>
                </div>

                <div>
                  <h3>Vehicle loan</h3>
                  <h5>(સાધન ધિરાણ)</h5>

                  <span className="amount-badge">
                    ₹૫,૦૦,૦૦૦/- (પાંચ લાખ) સુધી
                  </span>
                </div>
              </div>

              <div className="loan-features">
                <div className="loan-feature cyan1">
                  <i className="bi bi-car-front"></i>
                  <p>નવી અને જૂની બંને વાહન માટે</p>
                </div>

                <div className="loan-feature cyan1">
                  <i className="bi bi-percent"></i>
                  <p>ઓછી ડાઉન પેમેન્ટ</p>
                </div>

                <div className="loan-feature cyan1">
                  <i className="bi bi-check-circle-fill"></i>

                  <p>હપ્તા ની સંખ્યા</p>
                  <h2
                    style={{
                      fontSize: "20px",
                      marginBottom: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    ૧૨૦
                  </h2>
                </div>
              </div>

              <div className="loan-rate vehicle-rate">
                <span>વ્યાજ દર</span>
                <h2 style={{ marginBottom: "5px" }}>૧૮%</h2>
              </div>

              <div className="loan-image">
                <img src="images/vehicleloan.webp" alt="" />
              </div>
            </div>

            <div className="loan-footer">
              સુરક્ષિત ♦ વિશ્વસનીય ♦ ઝડપી મંજૂરી ♦ ગ્રાહક પ્રથમ
            </div>
          </div>
        </div>
      </div>

      <div className="trust-section">
        <div className="trust-header12">
          <h2
            style={{
              fontSize: "40px",
              color: "#ffeb3b",
              fontWeight: "bold",
              marginBottom: "30px",
            }}
          >
            તો પછી રાહ શેની જુઓ છો , આવો અને સોસાયટી નાં શેર સભાસદ બનો.
          </h2>

          <p style={{ color: "#f5f8fc", fontWeight: "bold", fontSize: "18px" }}>
            દરેક યોજનાની વિસ્તૃત માહિતી તેમજ સોસાયટીમાં શેર સભાસદ થવા માટે બહેનો
            ઓફિસે કાર્યાલયમાં મેનેજરશ્રી ને ઓફિસ સમય દરમિયાન રૂબરૂ મળો.
          </p>

          <p style={{ color: "#f5f8fc", fontWeight: "bold", fontSize: "18px" }}>
            કામકાજ નો સમય: સોમ થી શનિ :- 10:00 થી 5:00
          </p>
          <p style={{ color: "#f5f8fc", fontWeight: "bold", fontSize: "18px" }}>
            બીજા તથા ચોથા શનિવારે રજા રહેશે.
          </p>
          <button
            style={{
              fontSize: "18px",
              background: "#ffeb3b",
              color: "#0a2c42",
              width: "200px",
            }}
            onClick={() => navigate("/join")}
          >
            સંપર્ક કરો
          </button>
        </div>

        <div className="modern-container"></div>
      </div>

      {/* TEAM */}
      <div className="team-section">
        <h2>અમારી ટીમ</h2>

        <div className="team-container">
          {team.length > 0 ? (
            team.map((member, index) => (
              <div className="team-card" key={index}>
                <div className="team-image">
                  <img src={`${BASE_URL}/uploads/${member.photo}`} alt="" />
                </div>
                <div className="team-text">
                  <h3>{member.name}</h3>
                  <p>{member.role}</p>
                </div>
              </div>
            ))
          ) : (
            <p>No team members found</p>
          )}
        </div>
      </div>
    </div>
  );
}
